import axios from 'axios';

const API_URL = process.env.REACT_APP_URL_API;

class UploadService {

    uploadCsv(formData, typeFile) {

        return axios.post(API_URL+'import/file/csv/'+typeFile,
            formData
        , {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'Content-Type': 'multipart/form-data'
            },
        });

    }


}

export default new UploadService();
